<template>
  <div class="about">
    <h1>What's here?</h1>
    <p>
      The content of this website is the sermons and services at Oak Grove Baptist Church in San Jose California.Please visit the church <a href="https://www.oakgrovebaptistchurch.org/" target="_blank">website</a>.
    </p>
  </div>
</template>

